export default __webpack_public_path__ + "static/media/Vision.0198c6ee.png";